// extracted by mini-css-extract-plugin
module.exports = {"header":"OpenAuth_header__2qcsG","help-center-link":"OpenAuth_help-center-link__2xkAC"};